export default __webpack_public_path__ + "static/media/product-email-newsletter-series.7ef19f70.png";